module.exports = "{\r\n  id: \"mct\",\r\n  route: \"/myRoute?foo=bar\",\r\n  pathname: \"/myRoute\",\r\n  query: {foo: \"bar\"},\r\n  type: \"tile\"\r\n}\r\n";


/*****************
 ** WEBPACK FOOTER
 ** ./snippets/tileLayout.html
 ** module id = 269
 ** module chunks = 0
 **/